export const DOT_WIDTH = 7;
export const DOT_GAP = 8;
export const DOT_STEP = DOT_WIDTH + DOT_GAP;
export const CONTAINER_MARGIN = 2;
